export default "__VITE_ASSET__BqL44Vrl__"